module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAMCAYAAAAK/x/DAAAAAXNSR0IArs4c6QAAAMpJREFUOE9jrChtCf3PwDj1////ogwDCBgZGV8zMvzPZgS5obKyTfTf7//T/jP8DxkINzEyMK5hYmXMam+veg12EAzQO7RgodLRXbMa5gYUB9EztJBDBTlQMBxE69DCFipEOYgWoYUrVIh2ELVCi1CokOwgWGj9/fNvKsN/hlCSciIjw2pmFqZsUA4iRh/ONIRLM7E5kZRQISuEkDWByi28oUViqFDsIFxpi9xQoZqDQAY1NPSI/Pj6MxbE5uBmX9zQUPKGmLSCSw0ASud802/cia8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/sources/trigon1.png
// module id = 86sS
// module chunks = 96